import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import serverHost from "../../services/serverHost";
import { useHistory } from "react-router-dom";
import AppContext from "../../container/context";

export default function Pronuncia(props) {
  const [pronunciaId] = useState(props.match.params.id);
  const [pronuncia, setPronuncia] = useState({});
  const [filtros, setFiltros] = useState({});
  const history = props.history;
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (pronunciaId > 0) {
      carregarPronuncia();
    }
  }, []);

  const carregarPronuncia = () => {
    api
      .get("pronuncias/carregar", { id: pronunciaId })
      .then((res) => {
        setPronuncia(res);
      })
      .catch((err) => {
        alert("Erro ao carregar a pronúncia: " + err);
      });
  };

  const salvar = (form) => {
    const pronunciaSalvar = form;

    if (pronunciaId > 0) {
      pronunciaSalvar.id = Number(pronunciaId);

      atualizaPronuncia(pronunciaSalvar);
    } else {
      cadastraPronuncia(pronunciaSalvar);
    }
  };

  const atualizaPronuncia = (pronunciaSalvar) => {
    const data = new FormData();

    data.append("palavra", pronunciaSalvar.palavra);
    data.append("traducao", pronunciaSalvar.traducao);
    data.append("formaFigurada", pronunciaSalvar.formaFigurada);
    data.append("voz", pronunciaSalvar.voz);
    data.append("ativa", pronunciaSalvar.ativa);
    data.append("id", pronunciaSalvar.id);

    if (pronunciaSalvar.audio && pronunciaSalvar.audio[0]) {
      data.append("audio", pronunciaSalvar.audio[0]);

      const partesNome = pronunciaSalvar.audio[0].name.split(".");

      pronunciaSalvar.extensaoAudio = partesNome[partesNome.length - 1];

      if (pronunciaSalvar.extensaoAudio !== "mp3")
        return notification(
          "error",
          "O formato do arquivo de áudio deve ser mp3."
        );
    } else {
      if (pronuncia.extensaoAudio)
        pronunciaSalvar.extensaoAudio = pronuncia.extensaoAudio;
    }

    api.post("pronuncias/editar", data).then((res) => {
      if (res) {
        notification("success", "Atualizado com sucesso!");

        history.push("/app/pronuncia");
      } else {
        notification(
          "error",
          "Não foi possível salvar. Verifique as informações"
        );
      }
    });
  };

  const cadastraPronuncia = (pronunciaSalvar) => {
    const data = new FormData();

    data.append("palavra", pronunciaSalvar.palavra);
    data.append("traducao", pronunciaSalvar.traducao);
    data.append("formaFigurada", pronunciaSalvar.formaFigurada);
    data.append("voz", pronunciaSalvar.voz);

    if (pronunciaSalvar.audio && pronunciaSalvar.audio[0]) {
      data.append("audio", pronunciaSalvar.audio[0]);

      const partesNome = pronunciaSalvar.audio[0].name.split(".");

      pronunciaSalvar.extensaoAudio = partesNome[partesNome.length - 1];

      if (pronunciaSalvar.extensaoAudio !== "mp3")
        return notification(
          "error",
          "O formato do arquivo de áudio deve ser mp3."
        );
    }

    api.put("pronuncias/inserir", data).then((retorno) => {
      if (retorno) {
        notification("success", "Cadastrado com sucesso!");
        history.push("/app/pronuncia");
      } else {
        notification(
          "error",
          "Não foi possível cadastrar. Verifique as informações"
        );
      }
    });
  };

  const camposfiltros = () => {
    const campos = {
      palavra: {
        label: "Palavra",
        type: "text",
        space: 6,
        value: pronuncia.palavra,
      },
    };

    campos.traducao = {
      label: "Tradução",
      type: "text",
      space: 6,
      value: pronuncia.traducao,
    };

    campos.formaFigurada = {
      label: "Forma figurada",
      type: "text",
      space: 6,

      value: pronuncia.formaFigurada,
    };

    campos.voz = {
      type: "select",
      label: "Gênero (voz áudio)",
      emptyItem: true,
      value: pronuncia.voz,

      space: 6,
      options: [
        {
          value: "F",
          desc: "Feminino",
        },
        {
          value: "M",
          desc: "Masculino",
        },
      ],
    };

    campos.audio = {
      label: "Áudio da pronúncia (formato .mp3)",
      type: "file",
      // accept: "image/png, image/gif, image/jpeg",
      space: 6,
    };

    if (pronuncia.audio !== "" && pronunciaId > 0) {
      campos.player = {
        type: "component",
        value: (
          <audio
            preload="none"
            src={`${serverHost()}/${pronuncia.audio}`}
            controls
          />
        ),
        space: 6,
      };
    }

    if (pronunciaId > 0) {
      campos.ativa = {
        label: "Ativo",
        type: "check",
        value: pronunciaId > 0 ? pronuncia.ativa : undefined,
      };
    }

    return campos;
  };

  const fFiltros = {
    title: "Pronúncia",
    form: camposfiltros(filtros),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };
  return (
    <div>
      <Form formData={fFiltros} />
    </div>
  );
}
